export default __webpack_public_path__ + "static/media/cloudstory.3549f460.svg";